import React from 'react';
import TableData from './TableData';

export default {
  title: 'TableData/base',
  component: TableData
};

const Template = args => <TableData {...args} />;

export const Base = Template.bind({});
Base.args = {
  user: {}
};
